

// color-swatches.js

const COLOR_MAP = {
  'Amarillo': '#FFFF00',
  'Azul': '#005fac',
  'Azul marino': '#283146',
  'Azul Piedra': '#676870',
  'Arena': '#e7ce8c',
  'Beige': '#d5b587',
  'Beige / Blanco': '#d5b587',
  'Blanco': '#f0f0eb',
  'Blanco / Jade': '#f0f0eb',
  'Blanco / Naranjo': '#f0f0eb',
  'Burdeo': '#800020',
  'Calipso': '#00FFEF',
  'Camel': '#C19A6B',
  'Canela': '#D2691E',
  'Celeste': '#97b2d4',
  'Celeste / Azul Marino': '#97b2d4',
  'Coral': '#ff446f',
  'Coral / Durazno': '#ff446f',
  'Crema': '#e6dac2',
  'Durazno': '#f9c273',
  'Frambuesa': '#E30B5D',
  'Fucsia': '#FF00FF',
  'Grafito': '#4a444d',
  'Gris': '#d6d6d7',
  'Gris / Negro': '#bfc4c3',
  'Gris Claro': '#bfc4c3',
  'Gris Medio': '#66676f',
  'Gris Piedra': '#828282',
  'Gris Plata': '#c0c0c0',
  'Jade': '#8fc6b8',
  'Jade / Verde Claro': '#8fc6b8',
  'Ladrillo': '#B22222',
  'Lavanda': '#E6E6FA',
  'Lila': '#bcadcd',
  'Lila Oscuro': '#a581b8',
  'Malva': '#E0B0FF',
  'Melange Beige': '#E8DCC4',
  'Melange Grafito': '#464646',
  'Melange Gris': '#2b3332',
  'Melange Gris Claro': '#dfded7',
  'Melange Verde': '#89AC76',
  'Morado': '#800080',
  'Morado Claro': '#9370DB',
  'Morado Oscuro': '#653557',
  'Mostaza': '#FFE4B5',
  'Mostaza Oscuro': '#CC9933',
  'Naranjo': '#e0542c',
  'Negro': '#3f3738',
  'Negro / Blanco': '#3f3738',
  'Negro / Gris / Blanco': '#3f3738',
  'Negro / Rosado': '#3f3738',
  'Negro / Turquesa': '#3f3738',
  'Petroleo': '#005e5b',
  'Petróleo': '#005e5b',
  'Petroleo / Negro': '#005e5b',
  'Petroleo / Verde Lima': '#005e5b',
  'Print Celeste': '#97b2d4',
  'Print Rojo Anaranjado': '#d81c0c',
  'Rojo': '#FF0000',
  'Rojo Anaranjado': '#d81c0c',
  'Rojo Oscuro': '#8B0000',
  'Rosa': '#FFC0CB',
  'Rosado': '#cf5d80',
  'Taupe': '#8d7969',
  'Terracota': '#E2725B',
  'Triple Negro': '#232323',
  'Turquesa': '#00987f',
  'Turquesa Oscuro': '#00868B',
  'Verde': '#008000',
  'Verde lima': '#a2dd00',
  'Verde Oscuro': '#006400',
  'Vino': '#722F37',
  'Violeta': '#8F00FF',
  'Cafe': '#6F4E37',
  'Café': '#6F4E37'
};


function normalizeText(text) {
  return text.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function isLightColor(hexColor) {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 155;
}

class SimpleColorCheckboxManager {
  constructor() {
    this.processedElements = new WeakSet();
    this.observer = null;
    this.normalizedColorMap = Object.entries(COLOR_MAP).reduce((acc, [key, value]) => {
      acc[normalizeText(key)] = value;
      return acc;
    }, {});
  }

  init() {
    this.observer = new MutationObserver(() => this.updateColorCheckboxes());
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    this.updateColorCheckboxes();
  }

  updateColorCheckboxes() {
    const filterLabels = document.querySelectorAll('.facets__label:not([data-color-filter]), .mobile-facets__label:not([data-color-filter])');
    
    filterLabels.forEach(label => {
      if (this.processedElements.has(label)) return;
      
      const textElement = label.querySelector('.facet-checkbox__text-label');
      if (!textElement) return;
      
      const colorName = textElement.textContent.trim();
      const normalizedColorName = normalizeText(colorName);
      const colorHex = this.normalizedColorMap[normalizedColorName];
      
      if (colorHex) {
        this.processedElements.add(label);
        label.setAttribute('data-color-filter', 'true');
        
        if (isLightColor(colorHex)) {
          label.classList.add('light-color');
        }
        
        const rect = label.querySelector('svg rect');
        if (rect) {
          rect.setAttribute('fill', colorHex);
          rect.setAttribute('stroke', isLightColor(colorHex) ? '#ddd' : colorHex);
        }
      }
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Inicializar
const checkboxManager = new SimpleColorCheckboxManager();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => checkboxManager.init());
} else {
  checkboxManager.init();
}
